
























































import { Component, Vue } from "vue-property-decorator";

import { MemberManagementMemberService as memberApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import MemberAddressComponent from "@/components/admin/member/memberAddressComponent.vue";
import MemberInfoComponent from "@/components/admin/member/memberInfoComponent.vue";
import MemberOrderHistoryComponent from "@/components/admin/member/memberOrderHistoryComponent.vue";
import PostalCode from "@/components/common/postalCode.vue";

@Component({
  name: "MemberEditComponent",
  components: {
    QErrors,
    PostalCode,
    MemberInfoComponent,
    MemberAddressComponent,
    MemberOrderHistoryComponent,
  },
})
export default class MemberEditComponent extends Vue {
  public title = "会員の新規作成";
  public memberId = null;
  public member: any = {};
  public isShowInfo = true;
  public isShowAddress = false;
  public isShowOrder = false;

  public async mounted() {
    this.memberId = this.$router.currentRoute.params?.id;
    if (this.memberId) {
      const result = await memberApi.adminMemberShow({
        memberId: this.memberId,
      });
      this.member = result.data.member;
      this.title = `${this.member.fullName} の編集`;
    }
    const hash = this.$router.currentRoute.hash.slice(1);
    if (!hash || hash == "info") {
      this.showInfoComponent();
    } else if (hash == "address") {
      this.showAddressComponent();
    } else if (hash == "order") {
      this.showOrderComponent();
    }
  }

  public showInfoComponent() {
    (this.$refs.memberInfoComponent as MemberInfoComponent).show(this.member);
    this.isShowInfo = true;
    this.isShowAddress = false;
    this.isShowOrder = false;
  }

  public showAddressComponent() {
    (this.$refs.memberAddressComponent as MemberAddressComponent).show();
    this.isShowInfo = false;
    this.isShowAddress = true;
    this.isShowOrder = false;
  }

  public showOrderComponent() {
    (this.$refs
      .memberOrderHistoryComponent as MemberOrderHistoryComponent).show();
    this.isShowInfo = false;
    this.isShowAddress = false;
    this.isShowOrder = true;
  }

  public redirectToInfoComponent() {
    this.$router.replace({ hash: "info" }).catch((error) => {
      console.error(error);
    });
    this.showInfoComponent();
  }

  public redirectToAddressComponent() {
    this.$router.replace({ hash: "address" }).catch((error) => {
      console.error(error);
    });
    this.showAddressComponent();
  }

  public redirectToOrderComponent() {
    this.$router.replace({ hash: "order" }).catch((error) => {
      console.error(error);
    });
    this.showOrderComponent();
  }

  public cancel() {
    (this.$refs.memberInfoComponent as MemberInfoComponent).cancel();
  }
}
